import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import moment from "moment";

export default function useEpp2Started(){

    const {course} = useParams();

    const queryClient = useQueryClient();

    const data = queryClient.getQueryData(course);
    
    return !data?.dpcSession?.u3Start ? true :
        moment().valueOf() > moment(data?.dpcSession?.u3Start).valueOf()  
}